<template>
  <div>
    <lm-image1 :shadow="false" :scale="false" :src="swiper">
      <div slot="title">Build  your  Dream.</div>
    </lm-image1>
    <lm-swatches-block :space="43.75">
      <h2>Undergraduate Studies</h2>
      <lm-container>
        <lm-figuare1 :src="img1" :list="module1"></lm-figuare1>
      </lm-container>
    </lm-swatches-block>
    <lm-swatches-block backgroundColor="#2f2424" :space="43.75">
      <h2 style="color: #fff;">Graduate Studies</h2>
      <lm-container>
        <lm-figuare :src="a17" :list="module2"></lm-figuare>
      </lm-container>
    </lm-swatches-block>
    <lm-swatches-block :space="43.75">
      <lm-container>
        <!-- <h2>Master of Public Health Program</h2> -->
        <h2>Applying To Other Programs</h2>
        <lm-row :md-gutter="35">
          <lm-col :md-span="8" v-for="article in module4" :key="article.id">
            <lm-column
              :title="article.title"
              :description="article.intro"
              :links="article.articles"
            ></lm-column>
          </lm-col>
        </lm-row>
      </lm-container>
    </lm-swatches-block>
    <!-- <lm-swatches-block backgroundColor="#2f2424" :space="43.75">
      <h2 style="color: #fff;">Applying To Other Programs</h2>
      <lm-container>
        <lm-figuare :src="a17" :list="module4"></lm-figuare>
      </lm-container>
    </lm-swatches-block> -->
    <poster-module :type="1"></poster-module>
  </div>
</template>

<script>
import { frontArticles4Memu, frontThrMenu } from '@/api/api';
import { methodsMixins } from '@/mixins/index';
import PosterModule from '../column/components/PosterModule';

export default {
  components: {
    PosterModule
  },
  mixins: [methodsMixins],
  data() {
    return {
      swiper: require('@/assets/admission/swiper.png'),
      img1: require('@/assets/admission/1.jpg'),
      a17: require('@/assets/temp/17.jpg'),
      b16: require('@/assets/temp/b16.jpg'),
      b17: require('@/assets/temp/b17.jpg'),
      module1: [],
      module2: [],
      module3: [],
      module4: []
    }
  },
  created() {
    const list1 = [],
    list2 = [],
    list3 = [],
    list4 = [],
    list5 = [],
    list6 = [],
    list7 = [],
    list8 = [],
    list9 = [],
    list10 = [],
    list11 = [];
    this.getArticles('y0lm76n5u1', 'y0lw3p1xeq', list1);
    this.getArticles('y0lm76n5u1', 'y0lw3p1qpb', list2);
    this.getArticles('y0lm76n5u1', 'y0lw3p28xo', list3);
    this.getArticles('y0lm76n5u1', 'y0lw3p2liv', list4);
    this.getArticles('y0lm76n5u1', 'y0lwm0hf1v', list5);
    this.getArticles('y0lm76n5u1', 'y0lwm0hupk', list6);
    this.getArticles('y0lm76n5u1', 'y0lwm0i8vb', list7);
    this.getArticles('y0lm76n5u1', 'y0lwm0iscj', list8);
    this.getArticles('y0lm76n5u1', 'y0lwm0izww', list9);
    this.getArticles('y0lm76n5u1', 'y0lwm0jbpf', list10);
    this.getArticles('y0lm76n5u1', 'y0lwm0jnmy', list11);
    this.module1 = [{
      title: 'Undergraduate Eligibility',
      intro: 'About 200 freshmen are admitted to SMU each year. We review each applicant with an eye to academic excellence, intellectual vitality and personal context.',
      articles: list1
    }, {
      title: 'Undergraduate Programs',
      intro: 'About 30 programs are offered in English and in Chinese. Explore our Undergraduate Programs.',
      articles: list2
    }, {
      title: 'Undergraduate Application',
      intro: 'SMU has an institutional commitment to provide equal educational opportunities for qualified students. Learn more about our Application Procedure.',
      articles: list3
    }];
    this.module2 = [{
      title: 'Graduate Eligibility',
      intro: 'SMU seeks candidates who want to move the fields of medicine and biomedical sciences forward, whose past accomplishments show evidence for originality, creativity, and a capacity for independent, critical thinking, who are academically ready to succeed at SMU and whose personal qualities will serve them well in our profession.',
      articles: list4
    }, {
      title: 'Graduate Programs',
      intro: 'More than 100 programs are offered in English and in Chinese. Explore our Graduate Programs.',
      articles: list5
    }, {
      title: 'Graduate Application',
      intro: 'SMU recruits students who are passionate about their interests and who bring enthusiasm and creativity to their work. Learn more about our Application Procedure.',
      articles: list6
    }];
    this.module3 = [{
      title: 'Application from China Scholarship Council',
      intro: '',
      articles: list7
    }, {
      title: 'Application from Southern Medical University',
      intro: '',
      articles: list8
    }, {
      title: 'Program Description',
      intro: 'The “Master of Public Health” sponsored by the Ministry of Commerce of the People’s Republic of China, is a two-year English degree curriculum program under the administration of the Southern Medical University.',
      articles: list9
    }];
    this.module4 = [{
      title: 'Visiting Scholars',
      intro: 'Information for visiting scholars seeking positions at SMU.',
      articles: list11
    }, {
      title: 'Foundation Program',
      intro: 'SMU offers valuable opportunities to enable international students to meet the entry requirements of SMU not only in Chinese and cross-cultural communication, but also related professional knowledge.',
      articles: list10
    }];
  },
  methods: {
    getPageData() {
      // 
      frontArticles4Memu({
        memu1Id: 'y0lm76n5u1',
        memu2Id: 'y0lw3p1xeq',
        pageNumber: this.undergraduateList.pageNumber ++,
        pageSize: this.undergraduateList.pageSize
      }).then(res => {
        this.undergraduateList.list = res.data.list;
      })
      // 
      frontArticles4Memu({
        memu1Id: 'y0lm76n5u1',
        memu2Id: 'y0lw3p1qpb',
        pageNumber: this.graduate.pageNumber ++,
        pageSize: this.graduate.pageSize
      }).then(res => {
        this.graduate.list = res.data.list;
      })
      // 
      frontArticles4Memu({
        memu1Id: 'y0lm76n5u1',
        memu2Id: 'y0lw3p28xo',
        pageNumber: this.health.pageNumber ++,
        pageSize: this.health.pageSize
      }).then(res => {
        this.health.list = res.data.list.map(item => {
          item.links = [{
            menu1_id: item.menu1_id,
            menu2_id: item.menu2_id,
            article_url: item.article_url,
            article_title: item.article_title,
          }]
          return item;
        });
      })
      // 
      frontArticles4Memu({
        memu1Id: 'y0lm76n5u1',
        memu2Id: 'y0lw3p2liv',
        pageNumber: this.other.pageNumber ++,
        pageSize: this.other.pageSize
      }).then(res => {
        this.other.list = res.data.list;
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variable.scss';
@import '../home/index.scss';
</style>